export const getClosestDatesIndices = (datesArray, targetDate) => {
  // NOTE: We're expecting datesArray to have already been sorted in descending order
  // Convert targetDate to timestamp
  const targetTimestamp = new Date(targetDate).getTime()

  // Convert datesArray to timestamps
  const timestamps = datesArray.map(date => new Date(date).getTime())

  // Initialize indices
  let beforeIndex = -1
  let afterIndex = -1

  // Find the closest dates before and after the target date
  for (let i = 0; i < timestamps.length; i++) {
    if (timestamps[i] < targetTimestamp && beforeIndex === -1) {
      beforeIndex = i
      break
    } else if (timestamps[i] > targetTimestamp) {
      afterIndex = i
    }
  }

  return { beforeIndex, afterIndex }
}
